import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

let items = document.querySelectorAll(".gsap-item");
if( items.length > 0 ) {
    items.forEach(element => {

        gsap.from([element], {
            scrollTrigger: {
                trigger: element,
                start: "top bottom-=0",
            },
            y: 50,
            opacity: 0,
            duration: 0.5,
            ease: "power1.out",
            delay: .2,
            stagger: 1
        });
    });
}

let cards = document.querySelectorAll(".gsap-carousel");
cards.forEach(element => {

    let subitems = element.querySelectorAll(".gsap-card");
    if( subitems.length > 0 ) {
        gsap.from([subitems], {
            scrollTrigger: {
                trigger: element,
                start: "top bottom-=0",
            },
            y: 50,
            opacity: 0,
            duration: 0.5,
            ease: "power1.out",
            delay: .2,
            stagger: .2
        });
    }
});

window.addEventListener("load", (event) => {
    let carousels = document.querySelectorAll(".swiper");
    if (carousels) {
        carousels.forEach(element => {
            let swiper = new Swiper(element, {
                modules: [Navigation, Pagination],
                navigation: {
                    nextEl: element.querySelector('.swiper-button-next'),
                    prevEl: element.querySelector('.swiper-button-prev'),
                },
                pagination: {
                    el: element.querySelector('.swiper-pagination'),
                    clickable: true,
                },
                slidesPerView: 1,
                spaceBetween: 10,
                loop: true,
                autoplay: {
                    delay: 5000,
                },
                breakpoints: {
                    640: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                    1600: {
                        slidesPerView: 4,
                        spaceBetween: 20,
                    },
                },
                on: {
                    init: function() {
                        updateSlidesOpacity(this);
                    },
                    slideChange: function() {
                        updateSlidesOpacity(this);
                    }
                }
            });
        });
    }
});


function updateSlidesOpacity(swiper) {
    // Vyčistíme všem snímkům opacity
    swiper.slides.forEach(function(slide) {
        slide.style.opacity = '0.3';  // Základní opacity pro neviditelné snímky
    });

    // Projdeme viditelné snímky (slidesPerView)
    let activeSlides = swiper.slides.slice(swiper.activeIndex, swiper.activeIndex + swiper.params.slidesPerView);

    // Nastavíme opacity pro viditelné snímky
    activeSlides.forEach(function(slide) {
        slide.style.opacity = '1';  // Plná opacity pro snímky ve výhledu
    });
}
